import Navbar from "@/components/Mobile/Navbar.vue";
import Profil from "@/views/private/Profil.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/mon-profil",
        name: RouteEnum.PROFIL,
        components: {
            default: Profil,
            footer: Navbar
        }
    }
]
